export default __webpack_public_path__ + "static/media/user_guide_image.96990909.svg";